const headers = {
  'X-Host': 'cnes.datasus.gov.br',
  'X-Referer': 'http://cnes.datasus.gov.br',
};

export default headers;
